<!-- 产品中心 -->
<template>
  <div>
    <div id="cont">
      <div class="cont">
        <div class="cont_l">
          <div class="cont_l_01">
            <div class="cont_l_02">
              <img :src="images.cps_03">
            </div>
            <div class="cont_l_03">
              <ul class="lit01">
                <li class="lit01_c">
                  <p class="littitle">{{text.product1}}</p>
                  <ul class="lit02">
                    <li class="lit02_a">
                      <router-link to="/producten/ysjsen">{{text.product2}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/producten/lben">{{text.product3}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/producten/crqden">{{text.product4}}</router-link>
                    </li>
                  </ul>

                  <p class="littitle">{{text.product5}}</p>

                  <ul class="lit02">
                    <li class="lit02_a">
                      <router-link to="/producten/kcpen">{{text.product6}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/producten/hhxten">{{text.product7}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/producten/xtghjen">{{text.product8}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/producten/jsgen">{{text.product9}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/producten/nten">{{text.product10}}</router-link>
                    </li>
                  </ul>

                  <p class="littitle">{{text.product11}}</p>

                  <ul class="lit02">
                    <li class="lit02_a">
                      <router-link to="/producten/tszpen">{{text.product12}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/producten/lytken">{{text.product13}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/producten/yjmen">{{text.product14}}</router-link>
                    </li>
                  </ul>

                  <p class="littitle">{{text.product15}}</p>
                  <ul class="lit02">
                    <li class="lit02_a">
                      <router-link to="/producten/yybjen">{{text.product16}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/producten/cytqwen">{{text.product17}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/producten/chsen">{{text.product18}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/producten/ggtqwen">{{text.product19}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/producten/sfjtqwen">{{text.product20}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/producten/ptztqwen">{{text.product21}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/producten/lsrgsen">{{text.product22}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/producten/lsjyen">{{text.product23}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/producten/ysyen">{{text.product24}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/producten/rjen">{{text.product25}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/producten/lasen">{{text.product26}}</router-link>
                    </li>
                  </ul>
                  <p class="littitle">{{text.product27}}</p>
                  <ul class="lit02">
                    <li class="lit02_a">
                      <router-link to="/producten/hgylen">{{text.product28}}</router-link>
                    </li>
                  </ul>
                  <p class="littitle">{{text.product29}}</p>
                  <ul class="lit02">
                    <li class="lit02_a">
                      <router-link to="/producten/gtllen">{{text.product30}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/producten/jsmden">{{text.product31}}</router-link>
                    </li>
                    <li class="lit02_a">
                      <router-link to="/producten/bxxen">{{text.product32}}</router-link>
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
            <div class="cont_l_04"></div>
          </div>
        </div>
        <div class="cont_r">
          <div class="cont_r_t">
            <div class="cont_r_t01">
              <span>{{text.profile3}}</span>
              <span>：</span>
              <span>{{text.profile4}}</span>
              <span>-</span>
              <span>{{text.product33}}</span>
            </div>
          </div>
          <div class="cont_r_b">
            <div id="rightdiv">
              <router-view></router-view>
            </div>
            <div class="cont_r_b10">
              <router-link to="/bbsen" target="_blank">
                <img :src="images.scy_03">
              </router-link>
            </div>
            <div class="clear"></div>
          </div>
        </div>
        <div class="clear"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        scy_03: require("../../../assets/img/en/scy_03.jpg"),
        cps_03: require("../../../assets/img/en/cps_03.jpg")
      },
      text: {
        product1: "NON-FERROUS METALS",
        product2: "Brass Ingot/Bronze Ingot/Copper Ingot",
        product3: "Aluminum Coil/Aluminum Plate/Aluminum Foil/CanBody",
        product4: "Remelt Lead Ingot/Remelt Zinc Ingot",
        product5: "MINERALS, RE&FE ALLOY",
        product6: "Cr Ore/Mn Ore",
        product7: "Mischmetal",
        product8: "RE Silicide",
        product9: "Si Metal",
        product10: "FeNi/FeSi/FeMn/FeSiMn/FeMo/FeCr/FeTi/FeV",
        product11: "CARBONS & COAL",
        product12: "Electrode",
        product13: "Carbon Block/Anode/Electrode Paste/Graphite Block/",
        product14: "Metallurgical Coal",
        product15: "MEDICINES & HEALTH PRODUCTS",
        product16: "Huperzine A",
        product17: "Tea Extract",
        product18: "Theaflavin/Instant Tea",
        product19: "Pueraria Extract",
        product20: "Milk Thistle P.E",
        product21: "Grape Seed Extract",
        product22: "Chondroitin Sulfate",
        product23: "Glucosamine Sulfate 2KCl",
        product24: "Glucosamine HCl",
        product25: "L- Carnitine",
        product26: "L-Tyrosine/L-Arginine/Alpha Lipoic Acid",
        product27: "CHEMICALS",
        product28: "Titanium Dioxide/Sodium Carbonate Anhydrous/Alumin",
        product29: "RAW MATERIALS & STEEL PRODUCTS",
        product30: "Mn Lumpy/Mn Flake/Mn Briquettes",
        product31: "Mg Ingots/Mg Granulars/Calcium Granulars",
        product32: "Cored-wire",
        product33: "Products"
      }
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/en/product/product.vue